import React from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "../pages/Dashboard/Dashboard";
import Modules from "../pages/Modules/Modules";
import AddModule from "../pages/Modules/AddModule";
import EditModule from "../pages/Modules/EditModule";
import Programs from "../pages/Programs/Programs";
import AddProgram from "../pages/Programs/AddProgram";
import EditProgram from "../pages/Programs/EditProgram";
import Resources from "../pages/Resources/Resources";
import AddResource from "../pages/Resources/AddResource";
import EditResource from "../pages/Resources/EditResource";
import Categories from "../pages/Categories/Categories";
import AddCategory from "../pages/Categories/AddCategory";
import EditCategory from "../pages/Categories/EditCategory";
import MicroPractices from "../pages/MicroPractices/MicroPractices";
import AddMicroPractice from "../pages/MicroPractices/AddMicroPractice";
import EditMicroPractice from "../pages/MicroPractices/EditMicroPractice";
import Playlists from "../pages/Playlists/Playlists";
import AddPlaylist from "../pages/Playlists/AddPlaylist";
import EditPlaylist from "../pages/Playlists/EditPlaylist";
import Users from "../pages/Users/Users";
import AddUser from "../pages/Users/AddUser";
import EditUser from "../pages/Users/EditUser";
import Settings from "../pages/Settings/Settings";
import Roles from "../pages/Roles/Roles";
import Permissions from "../pages/Permissions/Permissions";

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path='/' element={<Dashboard />} />
      <Route path='/modules' element={<Modules />} />
      <Route path='/modules/add' element={<AddModule />} />
      <Route path='/modules/edit/:id' element={<EditModule />} />
      <Route path='/programs' element={<Programs />} />
      <Route path='/programs/add' element={<AddProgram />} />
      <Route path='/programs/edit/:id' element={<EditProgram />} />
      <Route path='/resources' element={<Resources />} />
      <Route path='/resources/add' element={<AddResource />} />
      <Route path='/resources/edit/:id' element={<EditResource />} />
      <Route path='/program-categories' element={<Categories />} />
      <Route
        path='/program-categories/add'
        element={<AddCategory />}
      />
      <Route
        path='/program-categories/edit/:id'
        element={<EditCategory />}
      />
      <Route path='/resource-categories' element={<Categories />} />
      <Route
        path='/resource-categories/add'
        element={<AddCategory />}
      />
      <Route
        path='/resource-categories/edit/:id'
        element={<EditCategory />}
      />
      <Route path='/categories' element={<Categories />} />
      <Route path='/micro-practices' element={<MicroPractices />} />
      <Route
        path='/micro-practices/add'
        element={<AddMicroPractice />}
      />
      <Route
        path='/micro-practices/edit/:id'
        element={<EditMicroPractice />}
      />
      <Route path='/playlists' element={<Playlists />} />
      <Route path='/playlists/add' element={<AddPlaylist />} />
      <Route path='/playlists/edit/:id' element={<EditPlaylist />} />
      <Route path='/users' element={<Users />} />
      <Route path='/users/add' element={<AddUser />} />
      <Route path='/users/edit/:id' element={<EditUser />} />
      <Route path='/roles' element={<Roles />} />
      <Route path='/permissions' element={<Permissions />} />
      <Route path='/settings' element={<Settings />} />
    </Routes>
  );
};

